export const getFormattedDate = (dateStr: string) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  const date = new Date(dateStr)

  const month = months[date.getUTCMonth()]
  const day = date.getUTCDate().toString().padStart(2, '0')
  const year = date.getUTCFullYear().toString().slice(2)

  return `${month} ${day}, ${year}`
}
export const getFormattedTime = (dateStr: string) => {
  const date = new Date(dateStr)

  let hours = date.getUTCHours()
  const minutes = date.getUTCMinutes().toString().padStart(2, '0')

  const ampm = hours >= 12 ? 'PM' : 'AM'

  if (hours > 12) {
    hours -= 12
  }
  if (hours === 0) {
    hours = 12
  }

  return `${hours}.${minutes} ${ampm}`
}
